import React from 'react';
import ContainerHome24 from '@/components/atoms/ContainerHome24';
import Styles from './BancoAutoFinancieCarro.css';
import WhiteButton from '@/components/atoms/WhiteButton';

function BancoAutoFinancieCarro() {
  return (
    <section id="banco-do-auto-financie-carro">
      <div className="bg-vermelho" />
      <img
        className="acelerador"
        src="assets/banco-do-auto25/ic_accelerator.svg"
        alt="acelerador"
      />
      <img
        className="acelerador desktop"
        src="assets/banco-do-auto25/ic_accelerator_desktop.svg"
        alt="acelerador"
      />
      <img
        className="segundo-acelerador"
        src="assets/banco-do-auto25/ic_acelerador.svg"
        alt="acelerador"
      />

      <ContainerHome24 className="container-financie">
        <div className="container-texto">
          <p className="paragrafo">
            Financiamento de até <b>100%</b> do valor
          </p>
        </div>
        <img className="caminhoes" src="assets/banco-do-auto25/Carros.svg" alt="Carros" />
        <div className="container-texto segundo">
          <p className="paragrafo">
            Financie em até <b>60x</b>
          </p>
        </div>

        <div className="container-texto-desktop">
          <div className="content">
            <div className="container-texto terceiro">
              <p className="paragrafo">
                <b>+800 mil</b> financiamentos de veículos por ano
              </p>
            </div>
            <div className="container-texto terceiro">
              <p className="paragrafo">
                <b>+60 anos</b>
                <br /> de experência em financiamento de veículos
              </p>
            </div>
            <div className="container-texto terceiro">
              <p className="paragrafo">
                <b>+25 milhões</b> de sonhos realizados com o financiamento Santander
              </p>
            </div>
          </div>
        </div>
        <WhiteButton
          className="financie-btn-white"
          href="https://www.cliente.santanderfinanciamentos.com.br/originacaocliente/?int_source=portalSF&amp;int_medium=banco-do-auto:3a-dobra&amp;int_campaign=simular-agora"
          target="_blank"
        >
          Simular agora
        </WhiteButton>
      </ContainerHome24>
      <img
        className="segundo-acelerador desktop"
        src="assets/banco-do-auto25/ic_acelerador-desktop.svg"
        alt="acelerador"
      />
      <style jsx>{Styles}</style>
    </section>
  );
}

export default BancoAutoFinancieCarro;
